module.exports = __webpack_public_path__ + "img/img-promo02-m.f71a6951.png";